import { render, staticRenderFns } from "./PatientNotes.vue?vue&type=template&id=207fa034&"
import script from "./PatientNotes.vue?vue&type=script&lang=js&"
export * from "./PatientNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports